import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Clock, Trophy } from 'lucide-react';
import RankingList from './RankingList';

/**
 * Aba de Ranking do afiliado — Semanal/Geral × AGENTE/HOST.
 */
const RankingTab = ({ reseller, weeklyRanking = [], generalRanking = [], rankingType, setRankingType }) => {
  const defaultTypeTab = reseller?.type || 'AGENTE';

  return (
    <Tabs value={rankingType} onValueChange={setRankingType}>
      <TabsList className="grid w-full grid-cols-2 bg-gray-100">
        <TabsTrigger
          value="weekly"
          className="data-[state=active]:bg-purple-600 data-[state=active]:text-white data-[state=inactive]:bg-purple-100 data-[state=inactive]:text-purple-600"
        >
          <Clock className="h-4 w-4 mr-2" />
          Ranking Semanal
        </TabsTrigger>
        <TabsTrigger
          value="general"
          className="data-[state=active]:bg-orange-600 data-[state=active]:text-white data-[state=inactive]:bg-orange-100 data-[state=inactive]:text-orange-600"
        >
          <Trophy className="h-4 w-4 mr-2" />
          Ranking Geral
        </TabsTrigger>
      </TabsList>

      <TabsContent value="weekly" className="mt-4 space-y-4">
        <Tabs defaultValue={defaultTypeTab}>
          <TabsList className="grid w-full grid-cols-2 bg-gray-100">
            <TabsTrigger value="AGENTE" className="data-[state=active]:bg-purple-600 data-[state=active]:text-white">
              💼 AGENTES
            </TabsTrigger>
            <TabsTrigger value="HOST" className="data-[state=active]:bg-orange-600 data-[state=active]:text-white">
              🎭 HOSTS
            </TabsTrigger>
          </TabsList>

          <TabsContent value="AGENTE" className="mt-3">
            <RankingList
              items={weeklyRanking.filter((r) => r.type === 'AGENTE')}
              coinsField="week_coins"
              coinsLabel="Esta semana"
              currentResellerId={reseller?.id}
              matchResellerBy="reseller_id"
              emptyMessage="Nenhum agente com vendas esta semana"
            />
          </TabsContent>

          <TabsContent value="HOST" className="mt-3">
            <RankingList
              items={weeklyRanking.filter((r) => r.type === 'HOST')}
              coinsField="week_coins"
              coinsLabel="Esta semana"
              currentResellerId={reseller?.id}
              matchResellerBy="reseller_id"
              emptyMessage="Nenhum host com vendas esta semana"
            />
          </TabsContent>
        </Tabs>
      </TabsContent>

      <TabsContent value="general" className="mt-4 space-y-4">
        <Tabs defaultValue={defaultTypeTab}>
          <TabsList className="grid w-full grid-cols-2 bg-gray-100">
            <TabsTrigger value="AGENTE" className="data-[state=active]:bg-purple-600 data-[state=active]:text-white">
              💼 AGENTES
            </TabsTrigger>
            <TabsTrigger value="HOST" className="data-[state=active]:bg-orange-600 data-[state=active]:text-white">
              🎭 HOSTS
            </TabsTrigger>
          </TabsList>

          <TabsContent value="AGENTE" className="mt-3">
            <RankingList
              items={generalRanking.filter((r) => r.type === 'AGENTE')}
              coinsField="total_sales_coins"
              coinsLabel="Total geral"
              currentResellerId={reseller?.id}
              matchResellerBy="id"
              emptyMessage="Nenhum agente no ranking"
            />
          </TabsContent>

          <TabsContent value="HOST" className="mt-3">
            <RankingList
              items={generalRanking.filter((r) => r.type === 'HOST')}
              coinsField="total_sales_coins"
              coinsLabel="Total geral"
              currentResellerId={reseller?.id}
              matchResellerBy="id"
              emptyMessage="Nenhum host no ranking"
            />
          </TabsContent>
        </Tabs>
      </TabsContent>
    </Tabs>
  );
};

export default RankingTab;
